import styled from 'styled-components';
import { DimmedStyled } from 'src/styles/common';
import { forwardRef, ReactNode } from 'react';

export const ModalWrap = styled.div<ModalStyles>`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  border-radius: 5px;
  width: ${(props) => (props.width ? props.width : '300px')};
  height: ${(props) => (props.height ? props.height : '400px')};
`;

interface ModalStyles {
  width?: string;
  height?: string;
}

interface ModalProps {
  children: ReactNode;
  onClick: (e: any) => void;

  styles?: ModalStyles;
}

const Modal = forwardRef<HTMLDivElement, ModalProps>((props, ref) => {
  return (
    <DimmedStyled ref={ref} onClick={props.onClick}>
      <ModalWrap style={props.styles}>{props.children}</ModalWrap>
    </DimmedStyled>
  );
});

export default Modal;
